export default {choose_newsletter:'Listeden haber bültenleri\'ni seçin.',email_please:'E-postan mı?'};